<template>
  <BoxBG>
    <template #main>
      <div
        class="d-flex flex-column align-center white custom-shadow main-login">
        <img
          class="mb-5"
          width="200"
          src="@/assets/img/logo.png" />
        <span
          class="text-h1-headline primary--text d-block text-center mt-3">
          เข้าสู่ระบบ
        </span>
        <div class="w-100 wrap-form">
          <ButtonSocial
            :disabled="submitting"
            class="mt-6 mb-3" />
          <div
            class="center-divider p-relative d-flex justify-center user-select-none my-5 my-md- my-lg-6">
            <div class="divider p-absolute"></div>
            <span class="grey--text white px-3">หรือ</span>
          </div>
          <div class="d-flex mb-2">
            <div class="primary--text text-h3-headline">
              Log-in ด้วยบัญชี Shipnity
            </div>
            <v-spacer />
            <a
              class="primary--text text-h3-headline"
              href="https://shipnity.com/landing"
              target="_blank">
              Shipnity คืออะไร?
            </a>
          </div>
          <HomeForm :submitting.sync="submitting" />
          <v-btn
            href="/authen/register"
            class="w-100 my-3"
            color="primary"
            height="40"
            outlined
            rounded
            depressed>
            ยังไม่ได้เป็นสมาชิก? สมัครสมาชิก
          </v-btn>
        </div>
      </div>
    </template>
  </BoxBG>
</template>

<script>
import { GET_ME_INFO } from '@/resources/graphql'
import { mapActions } from 'vuex'
import BoxBG from './components/BoxBG.vue'
import ButtonSocial from './components/ButtonSocial.vue'
import HomeForm from './components/HomeForm.vue'

export default {
  apollo: {
    me: {
      fetchPolicy: 'network-only',
      query: GET_ME_INFO,
      result () {
        if (this.me.id && process.env.VUE_APP_MODE === 'PRODUCTION') {
          window.location.href = process.env.VUE_APP_ADWORK
        }
      }
    }
  },
  metaInfo: {
    title: 'เข้าสู่ระบบ'
  },
  components: {
    BoxBG,
    HomeForm,
    ButtonSocial
  },
  data () {
    return {
      submitting: false,
      mounted: false,
      me: null
    }
  },
  methods: {
    ...mapActions({
      clearAuth: 'auth/clearAuth'
    }),
    goto (name) {
      this.$router.push({ name })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-text-field input[type='password'] {
    font-size: 1rem !important;
  }
}
</style>
